/**
 * 통계 막대 — 세로 막대(학년별)와 가로 막대(부서별). 오른쪽 칸 612px 에서도 넘치지 않게
 * 폭을 비율로만 정한다(설계 §9-1). 숫자는 늘 막대 옆에 글자로 — 색만으로 읽게 하지 않는다.
 */
import React from 'react';

const BAR = { primary: 'bg-primary', blue: 'bg-blue-300' };

/** 세로 막대 — items: [{label, value}] */
export function ColumnBars({ items, color = 'primary', ariaLabel, compact = false }) {
  const max = Math.max(1, ...items.map((it) => it.value));
  return (
    <div role="img" aria-label={ariaLabel} className={`flex items-end gap-1 ${compact ? 'h-24' : 'h-36'}`}>
      {items.map((it) => (
        <div key={it.label} className="flex h-full min-w-0 flex-1 flex-col items-center justify-end">
          <span className="text-xs text-gray-700">{it.value}</span>
          <div className={`w-3/5 rounded-t-sm ${BAR[color]}`} style={{ height: `${(it.value / max) * (compact ? 60 : 75)}%` }} />
          <span title={`${it.label} ${it.value}명`} className="mt-1 w-full truncate text-center text-xs text-gray-500">{it.label}</span>
        </div>
      ))}
    </div>
  );
}

/** 가로 막대 — items: [{label, value}] */
export function BarList({ items, color = 'primary', ariaLabel }) {
  const max = Math.max(1, ...items.map((it) => it.value));
  return (
    <div role="img" aria-label={ariaLabel} className="space-y-1.5">
      {items.map((it) => (
        <div key={it.label} className="flex items-center gap-2">
          <span className="w-16 shrink-0 truncate text-xs text-gray-500">{it.label}</span>
          <div className="h-3 min-w-0 flex-1 rounded-sm bg-gray-100">
            <div className={`h-full rounded-sm ${BAR[color]}`} style={{ width: `${(it.value / max) * 100}%` }} />
          </div>
          <span className="w-8 shrink-0 text-right text-xs text-gray-700">{it.value}</span>
        </div>
      ))}
    </div>
  );
}
